var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { State } from "../../../hooks/useUseCase";
import { Pagination } from "../models/Pagination";
import { defaultFilterConditionObject, FilterCondition } from "../models/FilterCondition";
import { ChangedFilterPayload } from "./usecase/payload/ChangedFIlterPayload";
import { ChangedSortPayload } from "./usecase/payload/ChangedSortPayload";
import { FetchedWorksErrorPayload } from "./usecase/payload/FetchedWorksErrorPyalod";
import { FetchedWorksPayload } from "./usecase/payload/FetchedWorksPayload";
import { FinishedLoadingPayload } from "./usecase/payload/FinishedLoadingPayload";
import { OpenedWorkSelectDialogPayload } from "./usecase/payload/OpenedWorkSelectDialogPayload";
import { SelectedWorkPayload } from "./usecase/payload/SelectedWorkPayload";
import { StartedLoadingPayload } from "./usecase/payload/StartedLoadingPayload";
import { UnselectedWorkPayload } from "./usecase/payload/UnselectedWorkPayload";
import { defaultSortConditionObject, SortCondition } from "../models/SortCondition";
import { createSelectedWorks } from "../models/SelectedWorks";
import { ClosedWorkSelectDialogPayload } from "./usecase/payload/ClosedWorkSelectDialogPayload";
var defaultPagination = {
    totalCount: 0,
    page: 1,
    lastPage: 1,
};
var WorkSelectDialogState = /** @class */ (function (_super) {
    __extends(WorkSelectDialogState, _super);
    function WorkSelectDialogState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.works = [];
        _this.selectedWorks = createSelectedWorks();
        _this.filterCondition = new FilterCondition(defaultFilterConditionObject);
        _this.sortCondition = new SortCondition(defaultSortConditionObject);
        _this.pagination = new Pagination(defaultPagination);
        _this.isLoading = false;
        _this.hasError = false;
        return _this;
    }
    Object.defineProperty(WorkSelectDialogState.prototype, "selectedWorkIds", {
        get: function () {
            return this.selectedWorks.works.map(function (work) { return work.id; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkSelectDialogState.prototype, "selectedUnavailableCourseWorkNames", {
        get: function () {
            return this.selectedWorks.unavailableCourseWorks.map(function (work) { return work.name; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkSelectDialogState.prototype, "selectedUnavailableWorkNames", {
        get: function () {
            return this.selectedWorks.unavailableWork.map(function (work) { return work.name; });
        },
        enumerable: false,
        configurable: true
    });
    WorkSelectDialogState.prototype.reduce = function (payload) {
        var _a;
        if (payload instanceof OpenedWorkSelectDialogPayload) {
            this.pagination = new Pagination(defaultPagination);
            this.selectedWorks = createSelectedWorks();
            this.selectedWorks.initialize(payload.defaultWork);
            return;
        }
        if (payload instanceof FetchedWorksPayload) {
            this.works = payload.works;
            this.pagination = (_a = payload.pagination) !== null && _a !== void 0 ? _a : new Pagination(defaultPagination);
            this.isLoading = false;
            return;
        }
        if (payload instanceof FetchedWorksErrorPayload) {
            this.hasError = true;
        }
        if (payload instanceof UnselectedWorkPayload) {
            this.selectedWorks.unselect(payload.work);
            return;
        }
        if (payload instanceof SelectedWorkPayload) {
            this.selectedWorks.select(payload.work);
            return;
        }
        if (payload instanceof ChangedFilterPayload) {
            this.filterCondition = payload.filterCondition;
            this.selectedWorks.clear();
            return;
        }
        if (payload instanceof ChangedSortPayload) {
            this.sortCondition = payload.sortCondition;
            return;
        }
        if (payload instanceof ClosedWorkSelectDialogPayload) {
            this.selectedWorks.clear();
            return;
        }
        if (payload instanceof StartedLoadingPayload) {
            this.isLoading = true;
            this.hasError = false;
            return;
        }
        if (payload instanceof FinishedLoadingPayload) {
            this.isLoading = false;
        }
    };
    return WorkSelectDialogState;
}(State));
export { WorkSelectDialogState };
export var initialWorkSelectDialogState = new WorkSelectDialogState();
